// @flow

import updateValuationField from '../../../Services/updateValuationField';

export default (value: string) => async (dispatch: Function) => {

  dispatch(updateValuationField('notes', value))

}